'use strict';
import('@/styles/main.css');

// import "@/styles/maze.css";
import { showToast } from '@/scripts/helpers/toast_helpers.js';
import { showErrorMsg } from '@/scripts/helpers/common_helpers';
import * as shareFeatureModule from './shareFeature.js';
import {
  loginApi as loginApiModule,
  authenticateCurUser as authenticateCurUserModule,
} from './auth/loginAuth.js';
import { apiBaseUrl } from './apiRoutes.js';
import { bindAccessTokenConsumer, setAccessToken } from './auth/authSession.js';
import { canExportCodelyActivity } from './auth/userAccess.js';
import { navigationIcons, homePageImages, iconIndexMap } from './img_sound_imports.js';
import {
  currLang,
  eng,
  hin,
  tam,
  ar,
  pa,
  mr,
  kn,
  gu,
  ur,
  sw,
  tl,
  cs,
  ne,
  setLanguage as setLanguageTranslation,
} from '@/scripts/translation.js';
import { conditionals_win_sound } from '@/scripts/img_sound_imports.js';
import { blocklyGame } from '@/scripts/config_datasim';
import { mountAppHeader } from './header/appHeader.js';
import { createPopover } from '@/scripts/header/popover.js';
import { isPageInList, isPageExact } from '@/scripts/helpers/pageUtils.js';
import '@/scripts/shell/shell.js';
import { createElement, Maximize2, Minimize2 } from 'lucide';
import { createShareModal } from '@/scripts/UI/shareModal.js';
import { initToolbarTooltips, registerTooltip } from '@/scripts/UI/tooltips/tooltips.js';

const excludedShellPages = [
  'login',
  'home',
  'level_home',
  'transitionxart',
  'build_practice',
  'musicxart',
  'transformation',
  'vernatics.html',
  'activities_published',
  'activities_saved',
];

if (typeof window !== 'undefined') {
  const currentPage = window.location.pathname.split('/').pop() || '';
  const shouldImportShellCss = !excludedShellPages.some((page) => currentPage.includes(page));

  if (shouldImportShellCss) {
    import('@/scripts/shell/shell.css');
  }
}

//hide preloader and reveal loaded page elements
const allowedPages = [
  'conditionals',
  'data_Simulation',
  'dragndrop',
  'events',
  'functions',
  'loops',
  'loops2',
  'nested_loops',
  'sequence',
  'variables',
];
function setupDots() {
  if (!isPageInList(allowedPages)) return;
  const toolbar = document.getElementById('toolbar');
  if (!toolbar) return;

  const dots = document.createElement('div');
  dots.classList.add('dots');

  toolbar.appendChild(dots);
}
function setupArowButtons() {
  const allowedPages = ['events.html', 'factory.html'];
  if (!isPageExact(allowedPages)) return;
  const toolbar = document.getElementById('toolbar');
  if (!toolbar) return;
  const arrowButtons = document.createElement('div');
  arrowButtons.id = 'arrow-button-container';
  arrowButtons.innerHTML = `<button class="left-btn dir-btn">
       <i data-lucide="circle-arrow-left"></i>
      </button>
      <button class="right-btn dir-btn">
        <i data-lucide="circle-arrow-right"></i>
      </button>
      <button class="up-btn dir-btn">
        <i data-lucide="circle-arrow-up"></i>
      </button>
      <button class="down-btn dir-btn">
        <i data-lucide="circle-arrow-down"></i>
      </button>`;

  toolbar.appendChild(arrowButtons);
}
function setupSpeedButtons() {
  const allowedPages = ['nested_loops.html', 'functions.html'];
  if (!isPageExact(allowedPages)) return;
  const toolbar = document.getElementById('toolbar');
  if (!toolbar) return;
  const speedButtons = document.createElement('div');
  speedButtons.id = 'speed-container';
  speedButtons.innerHTML = ` <div class="speed-container-content">
        <div class="custom-speed">
          <img
            class="custom-speed-img custom-speed-active"
            src="${navigationIcons.speed1}"
            data-img="1"
          />
          <img class="custom-speed-img" src="${navigationIcons.speed2}" data-img="2" />
          <img class="custom-speed-img" src="${navigationIcons.speed3}" data-img="3" />
          <img class="custom-speed-img" src="${navigationIcons.speed4}" data-img="4" />
        </div>
      </div>`;

  toolbar.appendChild(speedButtons);
}
export const hidePreloader = function () {
  let preLoaderEl = document.getElementById('pre-loader');
  preLoaderEl.style.display = 'none';
  if (localStorage.getItem('language') == null) localStorage.setItem('language', `[["eng"]]`);
  const vis = document.getElementById('visualisation');
  const mainLogin = document.querySelector('.main-content');
  let custom = document.querySelector('.custom-modal');
  const dirBtns = document.querySelectorAll('.dir-btn');
  const spdContainer = document.querySelector('#speed-container');
  const homeBtn = document.querySelector('.home-btn');
  const playNLearn = document.querySelector('.playnlearn');
  const animals = document.querySelector('.animals');
  const cardsEl = document.querySelectorAll('.card_el');
  const listEl = document.querySelectorAll('.list_el');
  const leafEl = document.querySelectorAll('.leaf');
  const scrollBtns = document.querySelectorAll('.scroll-btn');

  [
    vis,
    mainLogin,
    custom,
    spdContainer,
    ...dirBtns,
    homeBtn,
    playNLearn,
    animals,
    ...cardsEl,
    ...leafEl,
    ...listEl,
    ...scrollBtns,
  ].forEach((el) => {
    if (!el) return;
    el.style.display = 'block';
  });
};
let page = window.location.pathname.split('/').pop();
window.hidePreloader = hidePreloader;

//Config for starting dialog & wait time when winning a level
let waitTime = 1000;
let startdialogDuration = 3000;
let dropdownDivState = false;
let errorMsg = currLang['Game.ErrorMessage'];
let winnerMessage = `${currLang['Game.WinMessage']} 🎊🎉🎈`;
let winnerMessageWithBlocks = `${currLang['Sequence.WinMessage']}\n${currLang['Game.NumberOfBlocks']}`;
let state = {
  levelsArray: [['1'], ['1'], ['1'], ['1'], ['1'], ['1'], ['1'], ['1'], ['1'], ['1']],
  lang: [['eng']],
  // savedArray: [""],
};
let loginMode = 'login_redirect';
// let loginMode = "codelylogin";
let apiCallObj = {
  firstName: '',
  userName: '',
  passWord: '',
  userToken: '',
  apiBaseUrl,
  serverUrl: apiBaseUrl,
};
if (window.location.hostname.includes('test')) {
  loginMode = 'codelylogin';
}

if (sessionStorage.getItem('token')) {
  let savedToken = String(sessionStorage.getItem('token'));
  setAccessToken(savedToken);
}
bindAccessTokenConsumer((token) => {
  apiCallObj.userToken = token;
});
//Add common navigation  for all pages exept index

//Helpers
const setLanguage = async () => {
  const lang = document.getElementById('select-language').selectedIndex;
  console.log(lang);
  let selectedLanguage = document.getElementById('select-language').options[lang].value;
  state.lang = [[selectedLanguage]];
  preserveLevels(state.lang, 'language');

  // TODO: Remove location.reload() and implement dynamic UI updates
  // This would require updating all currLang usages to handle language changes
  location.reload();
};
const showMsg = function (msg) {
  let curEl = document.querySelector('.display-message');
  curEl.textContent = `${msg}`;
};
const showOverlay = function () {
  let overlay = document.getElementById('overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'overlay';
    document.body.appendChild(overlay);
  }
  overlay.style.display = 'flex';
};
const hideOverlay = function () {
  const overlay = document.getElementById('overlay');
  if (overlay) {
    setTimeout(() => {
      overlay.style.display = 'none';
    }, 500);
  }
};

function convertString(input) {
  const words = input.split('_');
  const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalizedWords.join(' ');
}

////////////////Responsible to load majority of page elements///////////////////////
const loadPageElements = function () {
  let page = window.location.pathname.split('/').pop();
  if (page.includes('login')) return;

  const language = localStorage.getItem('language');
  if (language.includes('eng')) {
    document.body.style.letterSpacing = '1px';
  }
  //Define navbar elements
  mountAppHeader();
  if (page.includes('home.html') || page == '') return;

  if (
    page.includes('index') ||
    page.includes('home') ||
    page.includes('build_practice') ||
    page.includes('transitionxart') ||
    page === 'vernatics.html' ||
    page.includes('musicxart') ||
    page.includes('activities') ||
    page.includes('transformation') ||
    page == ''
  )
    return;

  let modalWindow = document.createElement('div');
  let nextLvlButtonText = '';
  modalWindow.classList.add('modal-window', 'modal-window-win', 'box-appearance');
  let modalWindowHtml = ` <span class="close--modal"><i data-lucide="x"></i></span>
    <div class="modal-content">
      <h4 class="modal-text-content">
        Congratulations, You completed level one 🎉🎊
      </h4>
      <button class="next-level button">${currLang['Game.GoToNextLevel']}</button>
    </div>`;

  let bodyElements = [modalWindow];
  let bodyElementsHTML = [modalWindowHtml];
  bodyElements.forEach((el, i) => {
    document.body.appendChild(el);
    el.insertAdjacentHTML('afterbegin', bodyElementsHTML[i]);
  });
  //Event listener for instruction box

  let codeDialog1 = document.createElement('div');
  codeDialog1.classList.add('code-dialog', 'code-dialog-hidden', 'box-appearance');
  let codeDialogHtml = ` <span class="close-dialog"><i data-lucide="x"></i></span><p class="code-dialog-text">Your code didn't solve the game!</p>`;
  document.body.append(codeDialog1);
  codeDialog1.innerHTML = codeDialogHtml;

  const params = new URLSearchParams(window.location.search);
  const sharedId = params.get('shared');
  const showCode = params.get('showcode');
  AppShell.init({
    mode: showCode || !sharedId ? 'edit' : 'output-only',
    createPopover,
  });

  (function mountDeviceLogPanel() {
    const previewColumn = document.querySelector('.preview-column');
    const logPanel = document.getElementById('device-log-panel');
    if (previewColumn && logPanel) previewColumn.appendChild(logPanel);
  })();

  // Everything that needs shell to exist goes here
  (function mountBootElements() {
    const shellRoot = document.getElementById('app-shell');
    const toolbar = document.getElementById('toolbar');
    setupDots();

    // navBar.insertAdjacentHTML('afterbegin', navHtml);
    const iconAttributes = {
      stroke: '#ffffff', // Your color here
      width: '16', // Your size here
      height: '16',
      'stroke-width': '2',
    };
    let instructParent = document.createElement('div');
    instructParent.classList.add('instruct-parent', 'instruct-parent-hidden');
    let instructContent = document.createElement('div');
    // instructContent.classList.add("instruction-content", "box-appearance");<img class="apt-hero" src=${homePageImages.supra}>
    instructContent.classList.add('instruction-content');
    let instructContentHtml = `<div class="instruction-container">
      <div class="instruction-header"><span class="instruction-header-text">${currLang['Game.ActivityText']} ${currLang['Game.Instructions']}</span> <div class="instruct-header-btns"><span class="fullscreen--instruct">x</span> <span class="close--instruct"><i data-lucide="x"></i></span></div> </div>
     <div class="instruction-scrolldiv"><p class="instruction-content-text">
      ${currLang['Game.InstructionsContent']}
      </p>  </div></div> `;
    instructContent.innerHTML = instructContentHtml;
    let aptHero = document.createElement('img');
    aptHero.classList.add('apt-hero', 'apt-hero-hidden');
    aptHero.src = homePageImages.supra;
    document.body.appendChild(instructParent);
    instructParent.appendChild(instructContent);
    instructParent.appendChild(aptHero);
    const fullscreenBtn = document.querySelector('.fullscreen--instruct');
    fullscreenBtn.replaceChildren(createElement(Maximize2, iconAttributes));
    fullscreenBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (instructParent.classList.contains('instruct-parent-full')) {
        fullscreenBtn.replaceChildren(createElement(Maximize2, iconAttributes));
        instructParent.classList.remove('instruct-parent-full');
        instructContent.classList.remove('instruct-content-full');
      } else {
        fullscreenBtn.replaceChildren(createElement(Minimize2, iconAttributes));
        instructParent.classList.add('instruct-parent-full');
        instructContent.classList.add('instruct-content-full');
      }
    });

    // ── mount instruction panel ───────────────────────────────────────────
    shellRoot.appendChild(instructParent);
    instructParent.appendChild(instructContent);
    instructParent.appendChild(aptHero);

    // ── mount main button container into toolbar ──────────────────────────
    let page = window.location.pathname.split('/').pop();
    // ── run/reset buttons ─────────────────────────────────────────────────
    if (!page.includes('dragndrop')) {
      let runBtn1 = document.createElement('button');
      runBtn1.classList.add('run', 'toolbar-btn');
      runBtn1.id = 'run-btn';
      runBtn1.innerHTML = `<text class="control-btn"><span class="btn-label">${currLang['Game.RunButtonText']}</span><i data-lucide="square-play" stroke="#2eaf25"></i></text>`;

      let resetBtn1 = document.createElement('button');
      resetBtn1.classList.add('stop', 'toolbar-btn');
      resetBtn1.id = 'stop-btn';
      resetBtn1.innerHTML = `<text class="control-btn"><span class="btn-label">${currLang['Game.ResetButtonText']}</span><i data-lucide="rotate-ccw" stroke="#e14545"></i></text>`;
      resetBtn1.style.display = 'none';
      toolbar.appendChild(runBtn1);
      toolbar.appendChild(resetBtn1);
    }

    // ── share access button — vernatics only ────────────────────────────
    if (page.includes('vernatics')) {
      let shareBtn1 = document.createElement('button');
      shareBtn1.classList.add('toolbar-btn');
      shareBtn1.id = 'share-access-btn';
      shareBtn1.innerHTML = `<text class="control-btn"><i data-lucide="monitor-cog"></i></text>`;
      toolbar.appendChild(shareBtn1);

      if (import.meta.env.DEV) {
        let uploadModelBtn1 = document.createElement('button');
        uploadModelBtn1.classList.add('toolbar-btn');
        uploadModelBtn1.id = 'upload-model-btn';
        uploadModelBtn1.innerHTML = `<text class="control-btn"><i data-lucide="upload"></i></text>`;
        toolbar.appendChild(uploadModelBtn1);
      }

      let rsetBtn1 = document.createElement('button');
      rsetBtn1.classList.add('toolbar-btn');
      rsetBtn1.id = 'rset-btn';
      rsetBtn1.innerHTML = `<text class="control-btn"><i data-lucide="wifi-off" stroke="#ff6b6b"></i></text>`;
      toolbar.appendChild(rsetBtn1);
    }
    if (canExportCodelyActivity()) {
      let importBtn = document.createElement('button');
      importBtn.classList.add('import', 'toolbar-btn');
      importBtn.id = 'import-btn';
      importBtn.innerHTML = `<text class="control-btn"><span class="btn-label">Import</span><i data-lucide="file-input"></i></text>`;
      toolbar.appendChild(importBtn);

      let exportBtn = document.createElement('button');
      exportBtn.classList.add('export', 'toolbar-btn');
      exportBtn.id = 'export-btn';
      exportBtn.innerHTML = `<text class="control-btn"><span class="btn-label">Export</span><i data-lucide="file-output"></i></text>`;
      toolbar.appendChild(exportBtn);
    }
    initToolbarTooltips();
    setupArowButtons();
    setupSpeedButtons();

    // ── instruction button ────────────────────────────────────────────────
    let instructBtn1 = document.querySelector('.instruct-button');
    instructBtn1.innerHTML = `<text class="control-btn"><span class="btn-label">${currLang['Game.Instructions']}</span><i data-lucide="info"></i></text>`;
    registerTooltip(instructBtn1, currLang['Game.Instructions']);
    // ── vis area class (conditions preserved from original) ───────────────
    if (!page.includes('sketch') && !page.includes('compiler')) {
      let visArea = document.getElementById('visualisation');
      visArea?.classList.add('visDefault');
      if (page.includes('variables')) waitTime = 5000;
    }

    // Check query param once
    const urlParams = new URLSearchParams(window.location.search);
    const showInstructionsOnLoad = urlParams.get('showinstruction') === 'true';
    if (showInstructionsOnLoad) {
      showOverlay();
      instructParent.classList.remove('instruct-parent-hidden');
      aptHero.classList.remove('apt-hero-hidden');
    }
  })();

  // ── delegated event listeners on body — no timing dependency ─────────────
  // These go outside the IIFE because body always exists; they don't need
  // shell to be mounted, and delegation means it doesn't matter when the
  // target elements land in the DOM.
  let instructParent = document.querySelector('.instruct-parent');
  let instructContent = document.querySelector('.instruction-content');
  document.body.addEventListener('click', function (e) {
    e.stopPropagation();
    // close instruction box
    if (e.target.closest('.close--instruct')) {
      instructParent.classList.add('instruct-parent-hidden');
      hideOverlay();
      return;
    }
    // instruction button open/close
    if (e.target.closest('.instruct-button')) {
      instructParent.classList.toggle('instruct-parent-hidden');
      instructParent.classList.contains('instruct-parent-hidden') ? hideOverlay() : showOverlay();
      return;
    }
    // close modal
    if (e.target.closest('.close--modal')) {
      e.target.closest('.modal-window')?.classList.add('modal-hidden');
      hideOverlay();
      return;
    }
    // outside click closes menu + instruct (condition preserved from original)
    // ADDED: Check to make sure we didn't click inside the instruction parent container at all
    if (
      !e.target.closest('.instruction-content') &&
      !e.target.closest('.instructions') &&
      !e.target.closest('.instruct-parent') // <--- Add this safety check
    ) {
      const instructOpen = !instructParent.classList.contains('instruct-parent-hidden');
      if (instructOpen) {
        instructParent.classList.add('instruct-parent-hidden');
        hideOverlay();
      }
    }
  });

  document.body.addEventListener('touchstart', function (e) {
    if (
      !e.target.closest('.instruction-content') &&
      !e.target.closest('.instructions') &&
      !e.target.closest('.instruct-parent')
    ) {
      if (!instructParent.classList.contains('instruct-parent-hidden')) {
        instructParent.classList.add('instruct-parent-hidden');
        hideOverlay();
      }
    }
  });
};
loadPageElements();

///////////////Special conditions for index/activities/home pages///////////////
let curPage = window.location.pathname.split('/').pop();
if (
  curPage.includes('index') ||
  curPage.includes('home') ||
  curPage.includes('activities') ||
  curPage.includes('build_practice') ||
  page.includes('transitionxart') ||
  page === 'vernatics.html' ||
  page.includes('transformation') ||
  page.includes('musicxart') ||
  curPage == ''
) {
  let codeDialog1 = document.createElement('div');
  codeDialog1.classList.add('code-dialog', 'code-dialog-hidden', 'box-appearance');
  let codeDialogHtml = ` <span class="close-dialog"><i data-lucide="x"></i></span><p class="code-dialog-text"></p>`;
  document.body.appendChild(codeDialog1);
  codeDialog1.innerHTML = codeDialogHtml;
}
//Define object to store level data
//Set local torage with key and array
const preserveLevels = function (arr = state.levelsArray, name = 'levels') {
  localStorage.setItem(name, JSON.stringify(arr));
};
const loadLevels = function () {
  const storage = localStorage.getItem('levels');
  if (!storage) return;
  if (storage) {
    state.levelsArray = JSON.parse(storage);
  }
};

//Reset the completed level and saved levels data
const emptyLevels = function () {
  localStorage.clear();
  state.levelsArray = [['1'], ['1'], ['1'], ['1'], ['1'], ['1'], ['1'], ['1'], ['1'], ['1']];
  state.lang = [['eng']];
  // state.savedArray = [];
  preserveLevels();
  preserveLevels(state.lang, 'language');
  preserveLevels(state.savedArray, 'saved');
};
let latestPath = '';
let latestLang = {};

const shareLinkModal = createShareModal(() => ({
  title: latestLang['ShareModalTitle'] ?? 'Share',
  heading: latestLang['ShareModalText'],
  text: latestPath,
  copyLabel: latestLang['CopyButton.Text'] ?? 'Copy',
  copiedLabel: latestLang['Copied'] ?? 'Copied!',
}));

const showShareDialog = function (postID, level = null) {
  const params = new URLSearchParams();
  if (level) params.set('level', level);
  params.set('shared', postID);

  const sharePath = `${window.location.origin}${window.location.pathname}?${params.toString()}`;
  let checkWebview = sessionStorage.getItem('webviewActive');

  if (checkWebview) {
    sendBack(JSON.stringify({ type: 'share', body: `${sharePath}` }));
  } else {
    latestPath = sharePath;
    latestLang = currLang;
    new Audio(conditionals_win_sound).play();
    shareLinkModal.open();
  }
};

export function fromFlutter(token, pageReq = null) {
  if (window.location.pathname.includes('home.html')) {
    document.querySelector('.home-btn').remove();
  }
  if (!sessionStorage.getItem('token')) {
    setAccessToken(token);
    sessionStorage.removeItem('practicePage', JSON.stringify(false));
    if (pageReq) {
      sessionStorage.setItem('practicePage', JSON.stringify(true));
    }
    if (!pageReq) {
      sessionStorage.setItem('webviewActive', JSON.stringify(true));
    }
    let urlToRedirect = window.location.pathname;
    console.log(urlToRedirect);
    if (window.location.pathname.includes(loginMode)) {
      urlToRedirect = window.location.href.split('?')[1];
      urlToRedirect += window.location.search.slice(urlToRedirect.length + 1);
    } else {
      urlToRedirect = 'home.html';
    }

    window.location.href = urlToRedirect;
  } else {
    return;
  }
}
console.log(fromFlutter);
function sendBack(msg) {
  if (
    typeof messageHandler !== 'undefined' &&
    messageHandler &&
    typeof messageHandler.postMessage === 'function'
  ) {
    messageHandler.postMessage(msg);
  } else {
    console.warn('messageHandler not available, message not sent:', msg);
  }
}
console.log(eng, hin, tam, ar, pa, kn, mr, gu, ur, sw, tl, cs, ne);

window.fromFlutter = fromFlutter;
window.setLanguage = setLanguage;
//Add conditional styling for Hindi ,Arabic,Tamil
if (JSON.parse(localStorage.getItem('language'))[0][0] != 'eng') {
  document.body.style.fontWeight = 'bold';
  function addStyle(styleString) {
    const style = document.createElement('style');
    style.textContent = styleString;
    document.head.append(style);
  }

  addStyle(`
    .list li a  {
      -webkit-text-stroke: 0px rgb(0, 0, 0) !important;
      color: #301934 !important;
    }
    .list li a span {
      -webkit-text-stroke: 0px rgb(0, 0, 0) !important;
     color: #fdfdfd !important;
     background-color:rgba(255, 140, 0, 0.8) !important;
     border-radius:10px !important;
    }
    @media only screen and (max-width: 850px)
{
.slider:before {
      content: '${currLang['CodeButton.Text']}' !important ;
    }
    input:checked + .slider:before {
      content:'${currLang['BlocksButton.Text']}'  !important ;
    }
  }
  `);
}

const loginApi = async function (user, pass, urlRedirect = 'home.html') {
  try {
    let xyz = await loginApiModule(apiCallObj, {
      user,
      pass,
      urlRedirect,
      showMsg,
      currLang,
      curPage,
      loginMode,
    });
    return xyz;
  } catch (err) {
    console.error('loginApi error:', err);
    showMsg(currLang['Game.ErrorText']);
  }
};

const authenticateCurUser = function () {
  try {
    authenticateCurUserModule({
      apiCallObj,
      curPage,
      loginMode,
      showMsg,
      currLang,
      requestFromDatabase: shareFeatureModule.requestFromDatabase,
    });
  } catch (err) {
    console.error('authenticateCurUser error:', err);
  }
};

// Always defer past the current synchronous module-evaluation phase.
// Module scripts run after DOM parsing completes, so document.readyState
// is almost always already past 'loading' by this point — meaning the old
// `if (document.readyState !== 'loading') authenticateCurUser();` branch
// was firing synchronously, right in the middle of the boot.js<->
// shareFeature.js circular import resolution, before shareFeature.js had
// reached the line exporting requestFromDatabase. setTimeout(..., 0)
// guarantees the whole module graph has finished evaluating first.
setTimeout(function () {
  authenticateCurUser();
}, 0);
if (window.location.hostname.includes('portal')) console.clear(); //Remove in case of any bugs
export {
  loadPageElements,
  showShareDialog,
  preserveLevels,
  loadLevels,
  emptyLevels,
  waitTime,
  startdialogDuration,
  errorMsg,
  state,
  curPage,
  apiCallObj,
  winnerMessage,
  winnerMessageWithBlocks,
  setLanguage,
  sendBack,
  loginApi,
  showOverlay,
  hideOverlay,
};
export { page };
